export enum EmptySlotAdminClick {
  WhatToAdd = 0,
  ReservationsOnly = 1,
  DownTimeOnly = 2,
}
